import { Header, IconButton } from '@ixyberfree/ixybercomponents';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useStores } from 'store';
import styled from 'styled-components';
import Button from '../common/button/Button';
import * as hmiclientbase from '../hmilib/hmiclientbase';
import '../hmilib/hmiglobal';
import MonacoEditor from './MonacoEditor/MonacoEditor';
import TreeAPC, { ITreeAPC_branch } from './TreeAPC/TreeAPC';

const Wrapper = styled.div`
    background: #f8fafb;
    min-height: calc(100% - 4em);
    height: calc(100% - 4em);
    width: 100%;
    font-family: Roboto;
    display: flex;
    padding: 0 1em 1em 1em;
`;
const Card = styled.div`
    background: #ffffff;
    box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.05);
    margin: 1em;
    height: auto;
    padding: 1.6em 2em;
    overflow: auto;
`;
const RowEnd = styled.div`
    display: flex;
    justify-content: end;
`;
const Bottom = styled.div`
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 16px;
    color: #9f9f9f;
    margin-left: 1.4em;
    cursor: pointer;
`;

//Отслеживание были ли изменения в input
let EasySettingsChengeBool = false;

interface IPropsEasySettings {
    auth: {
        visibleAuth: boolean;
        authenticated: boolean;
        settingTrue: boolean;
        nameUser: string;
        callbackLogin: Function;
        callbackLogout: Function;
    };
}
interface ITempalate {
    name: string;
    type: string;
    incData: string;
    label: string;
}

const EasySettings: React.FC<IPropsEasySettings> = ({ auth }) => {
    const { SystemStore } = useStores();
    const firstRender = useRef(true);
    useEffect(() => {
        if (firstRender.current) {
            firstRender.current = false;
            return;
        }
    }, []);

    const [selectedElem, setSelectedElem] = useState<any>([]);
    const [visibleAddButton, setVisibleAddButton] = useState<any>(false);
    const [visibleDelButton, setVisibleDelButton] = useState<any>(false);
    const [sendData, setSendData] = useState<any>(false);
    const [newBlockFocusInp, setNewBlockFocusInp] = useState<any>(false);
    const [loadingScript, setLoadingScript] = useState<any>(false);
    const [scriptValue, setscriptValue] = useState<string>('');

    //загрузка первоначальных данных после отрисовки страницы
    const [units, setUnits] = useState<any>({});
    const [templates, setTemplates] = useState<any>({});
    const [namedSets, setNamedSets] = useState<any>({});
    const [scripts, setScripts] = useState<any>({});

    useEffect(() => {
        if (SystemStore.loadState) {
            hmiclientbase.EasySettingsGetUnits().then((res: any) => setUnits(res));
            hmiclientbase.EasySettingsGetTemplates().then((res: any) => setTemplates(parseTempaltes(res)));
            hmiclientbase.EasySettingsGetNamedSets().then((res: any) => setNamedSets(res));
            hmiclientbase.EasySettingsGetScripts().then((res: any) => setScripts(res));
        }
    }, [SystemStore.loadState]);

    const parseTempaltes = (str: string) => {
        let res: any = new Object();
        if (typeof str === 'string') {
            let arr = str.split('\r\n');

            arr.forEach((str) => {
                if (str.length > 0) {
                    let params = str.split(',');
                    if (res[params[0]] === undefined) {
                        res[params[0]] = new Array();
                    }
                    let t = res[params[0]];
                    if (Array.isArray(t) && params[1] !== '') {
                        t.push({
                            name: params[1],
                            type: params[2],
                            incData: params[3],
                            label: params[4]
                        });
                    }
                }
            });
        }
        return res;
    };

    const LoadScript = (name: string) => {
        hmiclientbase.EasySettingsGetScript(name).then((res: string) => {
            //console.debug(res);
            setscriptValue(res);
            setLoadingScript(false);
        });
        setLoadingScript(true);
    };
    //Создание дерева
    const [tree, setTree] = useState([]);
    useEffect(() => {
        createTree();
    }, [units, templates, namedSets, selectedElem]);
    const createTree = () => {
        let res: any = [];
        //
        let unitsBranch: ITreeAPC_branch = {
            name: 'Установки',
            class: '',
            type: 'folder',
            children: [],
            pointer: true,
            clickCallBack: () => {
                selectClick('units', undefined);
            },
            contextCallBack: (e) => {}
        };
        let listOfKeyUnits = Object.keys(units !== null ? units : {}).sort();
        listOfKeyUnits.forEach((key) => {
            if (typeof units[key] === 'object' && units[key] !== null) {
                let branch: ITreeAPC_branch = {
                    name: units[key].UnitDescription.length > 0 ? units[key].UnitDescription : key,
                    type: 'folder',
                    class: '',
                    children: [],
                    pointer: true,
                    clickCallBack: () => {
                        selectClick('unit', key);
                    },
                    contextCallBack: (e) => {},
                    editNameCallBack: changeParamTree,
                    editModeEnbl: newBlockFocusInp && selectedElem.join() === 'unit,' + key ? true : false,
                    editModeErrCB: () => {
                        selectClick('units', undefined);
                        setNewBlockFocusInp(false);
                    }
                };

                let mpk: ITreeAPC_branch = {
                    name: 'МПК',
                    class: '',
                    type: 'folder',
                    children: [],
                    pointer: true,
                    clickCallBack: () => {
                        selectClick('mpk', key);
                    },
                    contextCallBack: (e: any) => {
                        console.debug(e);
                    }
                };

                if (units[key].ProfitControllers != null) {
                    units[key].ProfitControllers.forEach((str: string, ind: number) => {
                        mpk.children?.push({
                            name: str,
                            type: 'file',
                            class: '',
                            iconUrl: 'static/images/tree_icon/gears.svg',
                            children: [],
                            pointer: true,
                            clickCallBack: () => {
                                selectClick('mpk', [key, ind]);
                            },
                            contextCallBack: (e) => {},
                            editNameCallBack: changeParamTree,
                            editModeEnbl:
                                newBlockFocusInp && selectedElem.join() === 'mpk,' + key + ',' + ind ? true : false,
                            editModeErrCB: () => {
                                selectClick('mpk', key);
                                setNewBlockFocusInp(false);
                            }
                        });
                    });
                }

                let va: ITreeAPC_branch = {
                    name: 'ВА',
                    class: '',
                    type: 'folder',
                    children: [],
                    pointer: true,
                    clickCallBack: () => {
                        selectClick('va', key);
                    },
                    contextCallBack: (e) => {}
                };

                if (units[key].SensorPros != null) {
                    units[key].SensorPros.forEach((str: string, ind: number) => {
                        va.children?.push({
                            name: str,
                            type: 'file',
                            iconUrl: 'static/images/tree_icon/loupe.svg',
                            children: [],
                            class: '',
                            pointer: true,
                            clickCallBack: () => {
                                selectClick('va', [key, ind]);
                            },
                            contextCallBack: (e) => {},
                            editNameCallBack: changeParamTree,
                            editModeEnbl:
                                newBlockFocusInp && selectedElem.join() === 'va,' + key + ',' + ind ? true : false,
                            editModeErrCB: () => {
                                selectClick('va', key);
                                setNewBlockFocusInp(false);
                            }
                        });
                    });
                }

                let interf: ITreeAPC_branch = {
                    name: 'Интерфейсы',
                    type: 'folder',
                    children: [],
                    class: '',
                    pointer: true,
                    clickCallBack: () => {},
                    contextCallBack: (e) => {}
                };

                if (interf.children != null) {
                    interf.children.push({
                        name: 'OPC',
                        type: 'file',
                        iconUrl: 'static/images/tree_icon/interfaceSquares.svg',
                        children: [],
                        class: '',
                        pointer: true,
                        clickCallBack: () => {
                            selectClick('OPC', key);
                        },
                        contextCallBack: (e) => {}
                    });
                }

                if (interf.children != null) {
                    interf.children.push({
                        name: 'Logs',
                        type: 'file',
                        iconUrl: 'static/images/tree_icon/interfaceSquares.svg',
                        children: [],
                        pointer: true,
                        class: '',
                        clickCallBack: () => {
                            selectClick('Logs', key);
                        },
                        contextCallBack: (e) => {}
                    });
                }

                if (branch.children != null) branch.children.push(mpk, va, interf);

                if (unitsBranch.children != null) unitsBranch.children.push(branch);
            }
        });
        res.push(unitsBranch);

        let templatesBranch: ITreeAPC_branch = {
            name: 'Шаблоны',
            type: 'folder',
            class: '',
            children: [],
            pointer: true,
            clickCallBack: () => {
                selectClick('templates', undefined);
            },
            contextCallBack: (e) => {}
        };
        let listOfKeyTemplates = Object.keys(templates).sort();
        listOfKeyTemplates.forEach((key) => {
            templatesBranch.children?.push({
                name: key,
                type: 'file',
                iconUrl: 'static/images/tree_icon/pazzle.svg',
                children: [],
                class: '',
                pointer: true,
                clickCallBack: () => {
                    selectClick('template', key);
                },
                contextCallBack: (e) => {},
                editNameCallBack: changeParamTree,
                editModeEnbl: newBlockFocusInp && selectedElem.join() === 'template,' + key ? true : false,
                editModeErrCB: () => {
                    selectClick('templates', undefined);
                    setNewBlockFocusInp(false);
                }
            });
        });
        res.push(templatesBranch);

        let namedSetsBranch: ITreeAPC_branch = {
            name: 'Поименованный набор',
            type: 'folder',
            children: [],
            class: '',
            pointer: true,
            clickCallBack: () => {
                selectClick('namedSets', undefined);
            },
            contextCallBack: (e) => {}
        };
        let listOfKeyNamedSets = Object.keys(namedSets).sort();
        let arrDublicate: any = {};
        listOfKeyNamedSets.forEach((key) => {
            let p = key.split('.');
            if (p.length === 2 && p[0].length > 0 && p[1].length > 0) {
                if (arrDublicate[p[0]] === undefined) {
                    let mBranch: ITreeAPC_branch = {
                        name: p[0],
                        type: 'folder',
                        class: '',
                        children: [],
                        pointer: true,
                        clickCallBack: () => {
                            selectClick('namedSetRoot', p[0]);
                        },
                        contextCallBack: (e) => {},
                        editNameCallBack: changeParamTree,
                        editModeEnbl: newBlockFocusInp && selectedElem.join() === 'namedSetRoot,' + p[0] ? true : false,
                        editModeErrCB: () => {
                            selectClick('namedSets', undefined);
                            setNewBlockFocusInp(false);
                        }
                    };
                    arrDublicate[p[0]] = mBranch;
                    namedSetsBranch.children?.push(mBranch);
                }
                arrDublicate[p[0]].children.push({
                    name: p[1],
                    type: 'file',
                    iconUrl: 'static/images/tree_icon/cube.svg',
                    children: [],
                    pointer: true,
                    clickCallBack: () => {
                        selectClick('namedSet', key);
                    },
                    contextCallBack: () => {},
                    editNameCallBack: changeParamTree,
                    selection: selectedElem.join() === 'namedSet,' + key,
                    editModeEnbl: newBlockFocusInp && selectedElem.join() === 'namedSet,' + key ? true : false,
                    editModeErrCB: () => {
                        selectClick('namedSetRoot', p[0]);
                        setNewBlockFocusInp(false);
                    }
                });
            }
        });
        res.push(namedSetsBranch);

        let scriptsBranch: ITreeAPC_branch = {
            name: 'Скрипты',
            type: 'folder',
            children: [],
            class: '',
            pointer: true,
            clickCallBack: () => {
                selectClick('scripts', undefined);
            },
            contextCallBack: (e) => {}
        };

        //console.debug(scripts);
        if (scripts instanceof Array) {
            let listOfKeyScripts: string[] = scripts;
            listOfKeyScripts.forEach((key) => {
                scriptsBranch.children?.push({
                    name: key,
                    type: 'file',
                    iconUrl: 'static/images/tree_icon/python_icon.svg',
                    children: [],
                    pointer: true,
                    class: '',
                    clickCallBack: () => {
                        selectClick('script', key);
                    },
                    contextCallBack: (e) => {},
                    editNameCallBack: changeParamTree,
                    editModeEnbl: newBlockFocusInp && selectedElem.join() === 'script,' + key ? true : false,
                    editModeErrCB: () => {
                        selectClick('scripts', undefined);
                        setNewBlockFocusInp(false);
                    }
                });
            });
        }
        res.push(scriptsBranch);

        setTree(res);
    };

    //Выделение selectedElem массив из типа объекта и ключа в этом объекте
    const selectClick = (type: string, key: any) => {
        let addButton = false;
        switch (type) {
            case 'scripts':
            case 'units':
            case 'templates':
            case 'namedSets':
            case 'namedSetRoot': {
                addButton = true;
                break;
            }
            case 'mpk':
            case 'va': {
                if (!Array.isArray(key)) addButton = true;
                break;
            }
        }
        setVisibleAddButton(addButton);
        let delButton = false;
        switch (type) {
            case 'script':
                LoadScript(key);
                break;
            case 'unit':
            case 'template':
            case 'namedSet':
            case 'namedSetRoot': {
                delButton = true;
                break;
            }
            case 'mpk':
            case 'va': {
                if (Array.isArray(key)) delButton = true;
                break;
            }
        }
        setVisibleDelButton(delButton);

        setSelectedElem([type, key]);
    };
    const selectRender = () => {
        switch (selectedElem[0]) {
            case 'unit':
            case 'OPC':
            case 'Logs': {
                return (
                    <UnitsView
                        type={selectedElem[0]}
                        unitName={selectedElem[1]}
                        inpObj={units[selectedElem[1]]}
                        inpCallBack={changeData}
                        blurCallBack={() => {
                            if (EasySettingsChengeBool) {
                                setSendData(!sendData);
                            }
                        }}
                    />
                );
            }
            case 'template': {
                return (
                    <TemplatesView
                        uniqID={selectedElem[1]}
                        inpArr={templates[selectedElem[1]]}
                        inpCallBack={changeData}
                        blurCallBack={() => {
                            if (EasySettingsChengeBool) {
                                setSendData(!sendData);
                            }
                        }}
                        addNewTemplateRow={addNewDataRow}
                        delTemplateRow={(delArr: any) => {
                            setOpenWarningWindowDel({
                                status: true,
                                confirmCB: () => {
                                    delDataRow(delArr);
                                    setOpenWarningWindowDel({ status: false, confirmCB: () => {}, delRowData: false });
                                },
                                delRowData: true
                            });
                        }}
                    />
                );
            }
            case 'namedSet': {
                return (
                    <NamedSetsView
                        uniqID={selectedElem[1]}
                        inpArr={namedSets[selectedElem[1]]}
                        inpCallBack={changeData}
                        blurCallBack={() => {
                            if (EasySettingsChengeBool) {
                                setSendData(!sendData);
                            }
                        }}
                        addNewNamedSet={addNewDataRow}
                        delNamedSet={(delArr: any) => {
                            setOpenWarningWindowDel({
                                status: true,
                                confirmCB: () => {
                                    delDataRow(delArr);
                                    setOpenWarningWindowDel({ status: false, confirmCB: () => {}, delRowData: false });
                                },
                                delRowData: true
                            });
                        }}
                    />
                );
            }
            case 'script': {
                if (loadingScript) {
                    return (
                        <Card style={{ width: '100%', overflow: 'hidden' }}>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    flexGrow: 1,
                                    width: '100%',
                                    height: '100%'
                                }}>
                                <img src="static/images/loading_hend.gif" style={{ height: '11em', width: '15em' }} />
                            </div>
                        </Card>
                    );
                } else {
                    return (
                        <Card style={{ width: '100%', overflow: 'hidden' }}>
                            <MonacoEditor
                                language="python"
                                value={scriptValue}
                                callbacOnChange={(value: string) => console.debug(value)}
                            />
                        </Card>
                    );
                }
            }
        }
    };

    //изменение данных
    const changeData = (attr: string, value: any, index?: number, namedSetsInd?: number) => {
        switch (selectedElem[0]) {
            case 'unit': {
                if (attr === 'unitName') {
                    let newUnits = JSON.parse(JSON.stringify(units));
                    newUnits[value] = units[selectedElem[1]];
                    delete newUnits[selectedElem[1]];
                    setSelectedElem([selectedElem[0], value]);
                    setUnits(newUnits);
                }
                break;
            }
            case 'OPC':
            case 'Logs': {
                let newUnits = JSON.parse(JSON.stringify(units));
                newUnits[selectedElem[1]][attr] = value;
                setUnits(newUnits);
                break;
            }
            case 'template': {
                let newTemplates = Object.assign({}, templates);
                newTemplates[selectedElem[1]][index!][attr] = value;
                setTemplates(newTemplates);
                break;
            }
            case 'namedSet': {
                let newNamedSets = Object.assign({}, namedSets);
                newNamedSets[selectedElem[1]][index!][attr] = value;
                setNamedSets(newNamedSets);
                break;
            }
        }
        EasySettingsChengeBool = true;
    };
    const changeParamTree = (value: any) => {
        switch (selectedElem[0]) {
            case 'mpk': {
                let newUnits = Object.assign({}, units);
                newUnits[selectedElem[1][0]].ProfitControllers[selectedElem[1][1]] = value;
                setUnits(newUnits);
                break;
            }
            case 'va': {
                let newUnits = Object.assign({}, units);
                newUnits[selectedElem[1][0]].SensorPros[selectedElem[1][1]] = value;
                setUnits(newUnits);
                break;
            }
            case 'unit': {
                let newUnits = JSON.parse(JSON.stringify(units));
                if (newUnits[selectedElem[1]].UnitDescription.length > 0) {
                    newUnits[selectedElem[1]].UnitDescription = value;
                    setUnits(newUnits);
                } else {
                    if (value !== selectedElem[1])
                        delete Object.assign(newUnits, { [value]: newUnits[selectedElem[1]] })[selectedElem[1]];
                    setUnits(newUnits);
                    setSelectedElem([selectedElem[0], value]);
                }
                break;
            }
            case 'template': {
                let newTemplates = Object.assign({}, templates);
                if (value !== selectedElem[1])
                    delete Object.assign(newTemplates, { [value]: newTemplates[selectedElem[1]] })[selectedElem[1]];
                setTemplates(newTemplates);
                setSelectedElem([selectedElem[0], value]);
                break;
            }
            case 'namedSet': {
                let p = selectedElem[1].split('.');
                if (value !== p[1]) {
                    if (namedSets[p[0] + '.' + value] !== undefined) {
                        alert(value + ' уже существует');
                        return;
                    }

                    let newNamedSets = Object.assign({}, namedSets);

                    if (value !== p[1])
                        delete Object.assign(newNamedSets, { [p[0] + '.' + value]: newNamedSets[selectedElem[1]] })[
                            selectedElem[1]
                        ];

                    setNamedSets(newNamedSets);
                    setSelectedElem([selectedElem[0], p[0] + '.' + value]);
                }
                break;
            }
            case 'namedSetRoot': {
                if (value !== selectedElem[1]) {
                    for (let key in namedSets) {
                        if (key.indexOf(value) >= 0) {
                            alert(value + ' уже существует');
                            return;
                        }
                    }

                    let newNamedSets = Object.assign({}, namedSets);

                    for (let oldKey in newNamedSets) {
                        if (oldKey.indexOf(selectedElem[1]) >= 0) {
                            let p = oldKey.split('.');
                            if (value !== p[0])
                                delete Object.assign(newNamedSets, { [value + '.' + p[1]]: newNamedSets[oldKey] })[
                                    oldKey
                                ];
                        }
                    }
                    setNamedSets(newNamedSets);
                    setSelectedElem([selectedElem[0], value]);
                }
                break;
            }
        }
        setSendData(!sendData);
        setNewBlockFocusInp(false);
    };
    //Добавление новых данных в Template b namedSets
    const addNewDataRow = (data: any) => {
        switch (selectedElem[0]) {
            case 'template': {
                let newTemplates = Object.assign({}, templates);
                newTemplates[selectedElem[1]].push(data);
                setTemplates(newTemplates);
                break;
            }
            case 'namedSet': {
                let newNamedSets = Object.assign({}, namedSets);
                newNamedSets[selectedElem[1]].push(data);
                setNamedSets(newNamedSets);
                break;
            }
        }
        setSendData(!sendData);
    };
    const delDataRow = (arrForDel: any[]) => {
        switch (selectedElem[0]) {
            case 'template': {
                let newTemplates = Object.assign({}, templates);
                let newArr: any = [];

                newTemplates[selectedElem[1]].forEach((elem: any, ind: number) => {
                    let fI = arrForDel.findIndex((item) => Number(item) === ind);
                    if (fI < 0) {
                        newArr.push(elem);
                    }
                });
                newTemplates[selectedElem[1]] = newArr;
                setTemplates(newTemplates);
                break;
            }
            case 'namedSet': {
                let newNamedSets = Object.assign({}, namedSets);
                let newArr: any = [];

                newNamedSets[selectedElem[1]].forEach((elem: any, ind: number) => {
                    let fI = arrForDel.findIndex((item) => Number(item) === ind);
                    if (fI < 0) {
                        newArr.push(elem);
                    }
                });
                newNamedSets[selectedElem[1]] = newArr;
                setNamedSets(newNamedSets);
                break;
            }
        }
        setSendData(!sendData);
    };

    //отправка данных на сервер
    useEffect(() => {
        if (!firstRender.current) {
            setData();
        }
    }, [sendData]);
    const setData = () => {
        switch (selectedElem[0]) {
            case 'unit':
            case 'units':
            case 'mpk':
            case 'va':
            case 'OPC':
            case 'Logs': {
                hmiclientbase.EasySettingsSetUnits(units);
                break;
            }
            case 'templates':
            case 'template': {
                let str = '';
                for (let key in templates) {
                    templates[key].forEach((row: any) => {
                        str = str + `${key},${row.name},${row.type},${row.incData},${row.label}\r\n`;
                    });
                    if (templates[key].length === 0) {
                        str = str + `${key},,,,\r\n`;
                    }
                }
                hmiclientbase.EasySettingsSetTemplates(str);
                break;
            }
            case 'namedSets':
            case 'namedSetRoot':
            case 'namedSet': {
                hmiclientbase.EasySettingsSetNamedSets(namedSets);
                break;
            }
        }
        EasySettingsChengeBool = false;
    };

    //Добавление и удаление блоков

    const [openWarningWindowDel, setOpenWarningWindowDel] = useState({
        status: false,
        confirmCB: () => {},
        delRowData: false
    });
    const addBlock = () => {
        switch (selectedElem[0]) {
            case 'units': {
                let newUnit = {
                    UnitDescription: '',
                    InterfaceNameOPCDA: 'OPC',
                    InterfaceHostOPCDA: '',
                    InterfaceUserOPCDA: '',
                    InterfacePasswodOPCDA: '',
                    clientOPCDAName: '',
                    clientOPCDAHostName: '',
                    clientOPCDAServerName: '',
                    clientOPCDALibname: 'OPCNET',
                    clientOPCDAServerGroupName: 'Group1',
                    InterfaceNameLOG: 'LOG',
                    InterfaceHostLOG: '',
                    InterfaceUserLOG: '',
                    InterfacePasswodLOG: '',
                    clientLOGName: 'UrtLog',
                    clientLOGupdateSec: 1000,
                    clientLOGpathLogsFiles: '',
                    ProfitControllers: [],
                    SensorPros: []
                };
                const checkNameUnit = (name: string) => {
                    for (let key in units) {
                        if (key === name) {
                            return true;
                        }
                    }
                    return false;
                };
                let nameUnit = 'Unit';
                let count = 1;
                while (checkNameUnit(nameUnit)) {
                    nameUnit = 'Unit' + count;
                    count++;
                }
                setUnits(Object.assign({ [nameUnit]: newUnit }, units));
                selectClick('unit', nameUnit);
                setNewBlockFocusInp(true);
                break;
            }
            case 'mpk': {
                if (!Array.isArray(selectedElem[1])) {
                    let newUnits = Object.assign({}, units);
                    newUnits[selectedElem[1]].ProfitControllers.push('ProfitController');
                    setUnits(newUnits);
                    selectClick('mpk', [selectedElem[1], newUnits[selectedElem[1]].ProfitControllers.length - 1]);
                    setNewBlockFocusInp(true);
                } else {
                    return;
                }
                break;
            }
            case 'va': {
                if (!Array.isArray(selectedElem[1])) {
                    let newUnits = Object.assign({}, units);
                    newUnits[selectedElem[1]].SensorPros.push('SensorPro');
                    setUnits(newUnits);
                    selectClick('va', [selectedElem[1], newUnits[selectedElem[1]].SensorPros.length - 1]);
                    setNewBlockFocusInp(true);
                } else {
                    return;
                }
                break;
            }
            case 'templates': {
                const checkNameTemplates = (name: string) => {
                    for (let key in templates) {
                        if (key === name) {
                            return true;
                        }
                    }
                    return false;
                };
                let nameTemplate = 'template_block';
                let count = 1;
                while (checkNameTemplates(nameTemplate)) {
                    nameTemplate = 'template_block' + count;
                    count++;
                }
                setTemplates(Object.assign({ [nameTemplate]: [] }, templates));
                selectClick('template', nameTemplate);
                setNewBlockFocusInp(true);
                break;
            }
            case 'namedSets': {
                const checkNameNamedSets = (name: any) => {
                    for (let key in namedSets) {
                        if (key.split('.')[0] === name) {
                            return true;
                        }
                    }
                    return false;
                };
                let nameBlock = 'block';
                let count = 1;
                while (checkNameNamedSets(nameBlock)) {
                    nameBlock = 'block' + count;
                    count++;
                }
                setNamedSets(Object.assign({ [nameBlock + '.block']: [] }, namedSets));
                selectClick('namedSetRoot', nameBlock);
                setNewBlockFocusInp(true);
                break;
            }
            case 'namedSetRoot': {
                const checkNameNamedSetRoot = (name: any) => {
                    for (let key in namedSets) {
                        let p = key.split('.');
                        if (selectedElem[1] === p[0] && p[1] === name) {
                            return true;
                        }
                    }
                    return false;
                };
                let nameBlock = 'block';
                let count = 1;
                while (checkNameNamedSetRoot(nameBlock)) {
                    nameBlock = 'block' + count;
                    count++;
                }
                setNamedSets(Object.assign({ [selectedElem[1] + '.' + nameBlock]: [] }, namedSets));
                selectClick('namedSet', selectedElem[1] + '.' + nameBlock);
                setNewBlockFocusInp(true);
                break;
            }
        }
        setSendData(!sendData);
    };
    const delBlock = () => {
        switch (selectedElem[0]) {
            case 'unit': {
                let newUnits = JSON.parse(JSON.stringify(units));
                delete newUnits[selectedElem[1]];
                setUnits(newUnits);
                selectClick('units', undefined);

                break;
            }
            case 'mpk': {
                if (Array.isArray(selectedElem[1])) {
                    let newUnits = JSON.parse(JSON.stringify(units));
                    newUnits[selectedElem[1][0]].ProfitControllers.splice(selectedElem[1][1], 1);
                    setUnits(newUnits);
                    selectClick('mpk', undefined);
                } else {
                    return;
                }
                break;
            }
            case 'va': {
                if (Array.isArray(selectedElem[1])) {
                    let newUnits = JSON.parse(JSON.stringify(units));
                    newUnits[selectedElem[1][0]].SensorPros.splice(selectedElem[1][1], 1);
                    setUnits(newUnits);
                    selectClick('va', undefined);
                } else {
                    return;
                }
                break;
            }
            case 'template': {
                let newTemplates = Object.assign({}, templates);
                delete newTemplates[selectedElem[1]];
                setTemplates(newTemplates);
                selectClick('templates', undefined);
                break;
            }
            case 'namedSet': {
                let newNamedSets = JSON.parse(JSON.stringify(namedSets));
                delete newNamedSets[selectedElem[1]];
                setNamedSets(newNamedSets);
                selectClick('namedSetRoot', selectedElem[1].split('.')[0]);
                break;
            }
            case 'namedSetRoot': {
                let newNamedSets = JSON.parse(JSON.stringify(namedSets));
                for (let key in newNamedSets) {
                    let p = key.split('.');
                    if (p[0] === selectedElem[1]) {
                        delete newNamedSets[key];
                    }
                }
                setNamedSets(newNamedSets);
                selectClick('namedSets', undefined);
                break;
            }
        }
        setSendData(!sendData);
    };
    const getTextMessage = () => {
        if (openWarningWindowDel.delRowData) {
            return 'Вы действительно хотите удалить выделенные элементы?';
        }
        switch (selectedElem[0]) {
            case 'mpk': {
                return `Вы действительно хотите удалить МПК ${units[selectedElem[1][0]].ProfitControllers[selectedElem[1][1]]}?`;
            }
            case 'va': {
                return `Вы действительно хотите удалить ВА ${units[selectedElem[1][0]].SensorPros[selectedElem[1][1]]}?`;
            }
            case 'unit':
                return `Вы действительно хотите удалить установку ${selectedElem[1]}?`;
            case 'template':
                return `Вы действительно хотите удалить шаблон ${selectedElem[1]}?`;
            case 'namedSet':
                return `Вы действительно хотите удалить поименованный набор ${selectedElem[1]}?`;
            case 'namedSetRoot':
                return `Вы действительно хотите удалить поименованный набор ${selectedElem[1]}?`;
        }
    };

    //Изменение окна с деревом ширина в em
    const [widthWindowTree, setWidthWindowTree] = useState(30);
    const [resizeTree, setResizeTree] = useState(false);
    const resizeWidthWindow = (e: React.MouseEvent) => {
        let width: number = e.pageX - 19;
        if (width > 150 && width < 750 && resizeTree) {
            setWidthWindowTree(width / 10);
        }
    };

    //render
    return (
        <>
            <Header
                homeElement={
                    <Link to={'/ixyber/vision/display/base'} title="Главная">
                        <IconButton imageUrl="Home" size="medium" />
                    </Link>
                }
                userName={auth.nameUser}
                isAllowed={auth.settingTrue}
                isAuthenticated={auth.authenticated}
                privateElements={
                    <>
                        <Link to="/ixyber/vision/display/settingmain" title="Настройки">
                            <IconButton imageUrl="Setting" size="medium" />
                        </Link>
                        <Link to="/ixyber/vision/display/EditorVision" title="Редактор">
                            <IconButton imageUrl="Editor" size="medium" />
                        </Link>
                    </>
                }
                callbackLogin={() => {
                    auth.callbackLogin();
                }}
                callbackLogout={() => {
                    auth.callbackLogout();
                }}></Header>
            <Wrapper
                onMouseUp={(e) => {
                    setResizeTree(false);
                }}
                onMouseMove={(e) => {
                    resizeWidthWindow(e);
                }}>
                <Card style={{ minWidth: widthWindowTree + 'em', display: 'flex', paddingRight: 0 }}>
                    <div style={{ width: 'calc(100% - 0.5em)', paddingRight: '2em' }}>
                        <RowEnd style={{ minHeight: '1.6em' }}>
                            {visibleDelButton && (
                                <Bottom
                                    onClick={() => {
                                        setOpenWarningWindowDel({
                                            status: true,
                                            confirmCB: () => {
                                                delBlock();
                                                setOpenWarningWindowDel({
                                                    status: false,
                                                    confirmCB: () => {},
                                                    delRowData: false
                                                });
                                            },
                                            delRowData: false
                                        });
                                    }}>
                                    Удалить
                                </Bottom>
                            )}
                            {visibleAddButton && (
                                <Bottom
                                    onClick={() => {
                                        addBlock();
                                    }}>
                                    + Добавить
                                </Bottom>
                            )}
                        </RowEnd>
                        <TreeAPC inpArr={tree} />
                    </div>
                    <div
                        style={{
                            background: '#fff',
                            width: '0.5em',
                            maxWidth: '0.5em',
                            cursor: 'col-resize'
                        }}
                        onMouseDown={(e) => {
                            setResizeTree(true);
                        }}></div>
                </Card>
                {selectRender()}
            </Wrapper>
            {openWarningWindowDel.status && (
                <WarningWindow
                    confirmCB={openWarningWindowDel.confirmCB}
                    cancelCB={() => {
                        setOpenWarningWindowDel({ status: false, confirmCB: () => {}, delRowData: false });
                    }}
                    message={getTextMessage()}
                />
            )}
        </>
    );
};

export default observer(EasySettings);

const TdText = styled.td`
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 16px;
    color: #626161;
    padding: 0;
`;
const TdInput = styled.input`
    padding: 0;
    min-width: 22em;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 16px;
    color: #000;
    border: 0.4px solid #cccccc;
    &:focus {
        outline: 0.4px solid #a5a5a5;
    }
`;
const TdSelect = styled.select`
    border: 0.4px solid #cccccc;
    &:focus {
        outline: 0.4px solid #a5a5a5;
    }
`;

interface IUnitsView {
    inpObj: any;
    type: string;
    unitName: string;
    inpCallBack?: Function;
    blurCallBack?: Function;
}
const UnitsView: React.FC<IUnitsView> = ({ inpObj, type, unitName, inpCallBack, blurCallBack }) => {
    const [autoSelectName, setAutoSelectName] = useState(false);

    const createCard = () => {
        switch (type) {
            case 'unit': {
                return (
                    <div key={unitName + 'unit'}>
                        <table>
                            <tbody>
                                <tr>
                                    <TdText>Имя:</TdText>
                                    <td>
                                        <TdInput
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    blurCallBack && blurCallBack();
                                                    setAutoSelectName(false);
                                                    e.currentTarget.blur();
                                                }
                                            }}
                                            autoFocus={autoSelectName}
                                            onFocus={() => {
                                                setAutoSelectName(true);
                                            }}
                                            defaultValue={unitName}
                                            onChange={(e) => {
                                                inpCallBack && inpCallBack('unitName', e.target.value);
                                            }}
                                            onBlur={() => {
                                                blurCallBack && blurCallBack();
                                                setAutoSelectName(false);
                                            }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <TdText>Описание:</TdText>
                                    <td>
                                        <TdInput
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    blurCallBack && blurCallBack();
                                                    e.currentTarget.blur();
                                                }
                                            }}
                                            /*defaultValue={inpObj.UnitDescription}*/ value={inpObj.UnitDescription}
                                            onChange={(e) =>
                                                inpCallBack && inpCallBack('UnitDescription', e.target.value)
                                            }
                                            onBlur={() => {
                                                blurCallBack && blurCallBack();
                                            }}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                );
            }
            case 'OPC': {
                return (
                    <div key={unitName + 'OPC'}>
                        <table>
                            <tbody>
                                <tr>
                                    <TdText style={{ color: '#000', fontWeight: 'normal' }} colSpan={2}>
                                        Интерфейс OPC DA
                                    </TdText>
                                </tr>
                                <tr style={{ minHeight: '2em', height: '2em' }}>
                                    <TdText colSpan={2}></TdText>
                                </tr>
                                <tr>
                                    <TdText colSpan={2}>Параметры шлюза МСУУТП</TdText>
                                </tr>
                                <tr>
                                    <TdText>Хост:</TdText>
                                    <td>
                                        <TdInput
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    blurCallBack && blurCallBack();
                                                    e.currentTarget.blur();
                                                }
                                            }}
                                            defaultValue={inpObj.InterfaceHostOPCDA}
                                            onChange={(e) =>
                                                inpCallBack && inpCallBack('InterfaceHostOPCDA', e.target.value)
                                            }
                                            onBlur={() => {
                                                blurCallBack && blurCallBack();
                                            }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <TdText>Имя пользователя:</TdText>
                                    <td>
                                        <TdInput
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    blurCallBack && blurCallBack();
                                                    e.currentTarget.blur();
                                                }
                                            }}
                                            defaultValue={inpObj.InterfaceUserOPCDA}
                                            onChange={(e) =>
                                                inpCallBack && inpCallBack('InterfaceUserOPCDA', e.target.value)
                                            }
                                            onBlur={() => {
                                                blurCallBack && blurCallBack();
                                            }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <TdText>Пароль:</TdText>
                                    <td>
                                        <TdInput
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    blurCallBack && blurCallBack();
                                                    e.currentTarget.blur();
                                                }
                                            }}
                                            defaultValue={inpObj.InterfacePasswodOPCDA}
                                            type={'password'}
                                            onChange={(e) =>
                                                inpCallBack && inpCallBack('InterfacePasswodOPCDA', e.target.value)
                                            }
                                            onBlur={() => {
                                                blurCallBack && blurCallBack();
                                            }}
                                        />
                                    </td>
                                </tr>
                                <tr style={{ minHeight: '2em', height: '2em' }}>
                                    <TdText colSpan={2}></TdText>
                                </tr>

                                <tr>
                                    <TdText colSpan={2}>Параметры сервера СУУ</TdText>
                                </tr>
                                <tr>
                                    <TdText>Имя хоста/IP:</TdText>
                                    <td>
                                        <TdInput
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    blurCallBack && blurCallBack();
                                                    e.currentTarget.blur();
                                                }
                                            }}
                                            defaultValue={inpObj.clientOPCDAHostName}
                                            onChange={(e) =>
                                                inpCallBack && inpCallBack('clientOPCDAHostName', e.target.value)
                                            }
                                            onBlur={() => {
                                                blurCallBack && blurCallBack();
                                            }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <TdText>Имя сервера:</TdText>
                                    <td>
                                        <TdInput
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    blurCallBack && blurCallBack();
                                                    e.currentTarget.blur();
                                                }
                                            }}
                                            defaultValue={inpObj.clientOPCDAServerName}
                                            onChange={(e) =>
                                                inpCallBack && inpCallBack('clientOPCDAServerName', e.target.value)
                                            }
                                            onBlur={() => {
                                                blurCallBack && blurCallBack();
                                            }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <TdText>Название библиотеки:</TdText>
                                    <TdText>
                                        <TdSelect
                                            value={inpObj.clientOPCDALibname}
                                            onChange={(e) => {
                                                inpCallBack && inpCallBack('clientOPCDALibname', e.target.value);
                                            }}
                                            onBlur={() => {
                                                blurCallBack && blurCallBack();
                                            }}>
                                            <option value={'OPCNET'}>OPCNET</option>
                                            <option value={'OPCAutomation'}>OPCAutomation</option>
                                        </TdSelect>
                                    </TdText>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                );
            }
            case 'Logs': {
                return (
                    <div key={unitName + 'Logs'}>
                        <table>
                            <tbody>
                                <tr>
                                    <TdText style={{ color: '#000', fontWeight: 'normal' }} colSpan={2}>
                                        Интерфейс Logs
                                    </TdText>
                                </tr>
                                <tr style={{ minHeight: '2em', height: '2em' }}>
                                    <TdText colSpan={2}></TdText>
                                </tr>
                                <tr>
                                    <TdText colSpan={2}>Параметры шлюза МСУУТП</TdText>
                                </tr>
                                <tr>
                                    <TdText>Хост:</TdText>
                                    <td>
                                        <TdInput
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    blurCallBack && blurCallBack();
                                                    e.currentTarget.blur();
                                                }
                                            }}
                                            defaultValue={inpObj.InterfaceHostLOG}
                                            onChange={(e) =>
                                                inpCallBack && inpCallBack('InterfaceHostLOG', e.target.value)
                                            }
                                            onBlur={() => {
                                                blurCallBack && blurCallBack();
                                            }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <TdText>Имя пользователя:</TdText>
                                    <td>
                                        <TdInput
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    blurCallBack && blurCallBack();
                                                    e.currentTarget.blur();
                                                }
                                            }}
                                            defaultValue={inpObj.InterfaceUserLOG}
                                            onChange={(e) =>
                                                inpCallBack && inpCallBack('InterfaceUserLOG', e.target.value)
                                            }
                                            onBlur={() => {
                                                blurCallBack && blurCallBack();
                                            }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <TdText>Пароль:</TdText>
                                    <td>
                                        <TdInput
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    blurCallBack && blurCallBack();
                                                    e.currentTarget.blur();
                                                }
                                            }}
                                            defaultValue={inpObj.InterfacePasswodLOG}
                                            type={'password'}
                                            onChange={(e) =>
                                                inpCallBack && inpCallBack('InterfacePasswodLOG', e.target.value)
                                            }
                                            onBlur={() => {
                                                blurCallBack && blurCallBack();
                                            }}
                                        />
                                    </td>
                                </tr>
                                <tr style={{ minHeight: '2em', height: '2em' }}>
                                    <TdText colSpan={2}></TdText>
                                </tr>
                                <tr>
                                    <TdText colSpan={2}>Параметры сервера СУУ</TdText>
                                </tr>
                                <tr>
                                    <TdText>Путь к файлам:</TdText>
                                    <td>
                                        <TdInput
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    blurCallBack && blurCallBack();
                                                    e.currentTarget.blur();
                                                }
                                            }}
                                            defaultValue={inpObj.clientLOGpathLogsFiles}
                                            onChange={(e) =>
                                                inpCallBack && inpCallBack('clientLOGpathLogsFiles', e.target.value)
                                            }
                                            onBlur={() => {
                                                blurCallBack && blurCallBack();
                                            }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <TdText>Время обновления:</TdText>
                                    <td style={{ display: 'flex', alignItems: 'center' }}>
                                        <TdInput
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    if (
                                                        999 > Number(e.currentTarget.value) ||
                                                        Number(e.currentTarget.value) > 90000001
                                                    ) {
                                                        e.currentTarget.value = e.currentTarget.defaultValue;
                                                    }
                                                    blurCallBack && blurCallBack();
                                                    e.currentTarget.blur();
                                                }
                                            }}
                                            type="number"
                                            step={1}
                                            min={1000}
                                            max={90000000}
                                            style={{ width: '6em', minWidth: '6em', textAlign: 'end' }}
                                            defaultValue={inpObj.clientLOGupdateSec}
                                            onChange={(e) => {
                                                if (e.target.value.length > 0) {
                                                    e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                                }
                                                if (999 < Number(e.target.value) && Number(e.target.value) < 90000001) {
                                                    inpCallBack &&
                                                        inpCallBack('clientLOGupdateSec', Number(e.target.value));
                                                }
                                            }}
                                            onBlur={(e) => {
                                                if (999 > Number(e.target.value) || Number(e.target.value) > 90000001) {
                                                    e.target.value = e.target.defaultValue;
                                                }
                                                blurCallBack && blurCallBack();
                                            }}
                                        />
                                        <TdText>мс</TdText>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                );
            }
        }
    };

    return <Card style={{ height: 'fit-content' }}>{createCard()}</Card>;
};

const Table = styled.table`
    border-collapse: collapse;
    border: 1px solid #a5a5a5;
    width: 100%;
`;
const TemplateInput = styled.input`
    padding: 0;
    font-style: normal;
    font-weight: 300;
    font-size: 13px;
    line-height: 15px;
    color: #4c4b4b;
    border: 0.4px solid #cccccc;
    width: 100%;
    &:focus {
        outline: 0.4px solid #a5a5a5;
    }
`;
const TemplateTh = styled.th`
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 15px;
    color: #4c4b4b;
    padding: 0;
    position: relative;
    width: 50%;
`;
const TemplateTr = styled.tr`
    min-height: 2.5em;
    height: 2.5em;
    border-bottom: 1px solid #a5a5a5;
    display: flex;
    align-items: center;
`;
const TemplateTd = styled.td`
    padding: 0 0.4em 0 0.8em;
    position: relative;
    width: 50%;
`;
const TemplateText = styled.div`
    font-style: normal;
    font-weight: 300;
    font-size: 13px;
    line-height: 15px;
    color: #9f9f9f;
    padding: 0 25px 14px 0;
`;
const TemplateSelect = styled.select`
    font-style: normal;
    font-weight: 300;
    font-size: 13px;
    line-height: 15px;
    color: #4c4b4b;
    border: 0.4px solid #cccccc;
    position: relative;
    width: 100%;
    border: 0.4px solid #cccccc;
    &:focus {
        outline: 0.4px solid #a5a5a5;
    }
`;

interface ITemplatesView {
    inpArr: any[];
    uniqID: string;
    inpCallBack?: Function;
    blurCallBack?: Function;
    addNewTemplateRow?: Function;
    delTemplateRow?: Function;
}
const TemplatesView: React.FC<ITemplatesView> = ({
    inpArr,
    uniqID,
    inpCallBack,
    blurCallBack,
    addNewTemplateRow,
    delTemplateRow
}) => {
    const arrTypes = [
        'string',
        'long',
        'enum',
        'float',
        'short',
        'int',
        'string[]',
        'long[]',
        'enum[]',
        'float[]',
        'short[]',
        'int[]'
    ];

    const bodyContainer: React.LegacyRef<HTMLTableSectionElement> = useRef(null);
    const selectAllBool = useRef(false);
    const [focusOnNewRow, setFocusOnNewRow] = useState<any>(false);
    const [inCorrectValue, setInCorrectValue] = useState<any>(null);
    const [selectDelButton, setSelectDelButton] = useState<any>(false);
    const [selectAllSelButton, setSelectAllSelButton] = useState<any>(false);

    const checkCorrectValue = (valueName: string, ind: any) => {
        let findInd = inpArr.findIndex((r) => r.name.toLowerCase() === valueName.toLowerCase());
        if ((findInd > -1 || valueName.length === 0) && findInd !== ind) {
            setInCorrectValue(ind);
        } else {
            inCorrectValue !== null && setInCorrectValue(null);
        }
        if (ind === 'addNewTemplateRow' && valueName.length === 0) {
            inCorrectValue !== null && setInCorrectValue(null);
        }
    };
    const addNewData = (tr: any) => {
        let td = tr.querySelectorAll('td');
        console.log(td);

        if (td[1].children[0].value.length !== 0) {
            let newData: ITempalate = {
                name: td[1].children[0].value,
                type: td[2].children[0].value,
                incData: td[3].children[0].value,
                label: td[4].children[0].value
            };
            addNewTemplateRow && addNewTemplateRow(newData);
            setFocusOnNewRow(true);
            td.forEach((td: any, ind: number) => {
                if (ind !== 0) {
                    if (td.children[0].nodeName === 'SELECT') {
                        td.children[0].value = 'string';
                    } else {
                        td.children[0].value = '';
                    }
                }
            });
        }
    };

    useEffect(() => {
        checkToSelect();
    });

    const checkToSelect = () => {
        if (bodyContainer.current) {
            let checkBoxs: any = bodyContainer.current.querySelectorAll('input[type="checkbox"]');
            let countChecked: number = 0;
            for (let cnt = 0; cnt < checkBoxs.length; cnt++) {
                if (checkBoxs[cnt].checked) {
                    countChecked++;
                }
            }
            if (countChecked === 0) {
                setSelectDelButton(false);
                setSelectAllSelButton(false);
            } else if (countChecked === checkBoxs.length) {
                setSelectAllSelButton(true);
                setSelectDelButton(true);
            } else {
                setSelectDelButton(true);
                setSelectAllSelButton(false);
            }
        }
    };

    const selectAll = () => {
        if (bodyContainer.current) {
            let checkBoxs = bodyContainer.current.querySelectorAll('input[type="checkbox"]');
            checkBoxs.forEach((box: any) => {
                if (selectAllBool.current) {
                    box.checked = false;
                } else {
                    box.checked = true;
                }
            });
            selectAllBool.current = !selectAllBool.current;
            checkToSelect();
        }
    };
    const delSelectedRow = () => {
        if (selectDelButton) {
            if (bodyContainer.current) {
                let checkBoxs = bodyContainer.current.querySelectorAll('input[type="checkbox"]');
                let massForDel: any[] = [];
                checkBoxs.forEach((box: any) => {
                    if (box.checked) {
                        massForDel.push(box.value);
                    }
                });
                //checkBoxs.forEach((box:any) => { box.checked = false; })
                delTemplateRow && delTemplateRow(massForDel);
                checkToSelect();
            }
        }
    };

    return (
        <Card style={{ width: '100%' }}>
            <div style={{ display: 'flex' }}>
                <TemplateText
                    style={{
                        cursor: 'pointer',
                        fontSize: '1.4em',
                        fontWeight: selectAllSelButton ? 'normal' : 300,
                        color: selectAllSelButton ? '#686868' : '#9F9F9F'
                    }}
                    onClick={() => {
                        selectAll();
                    }}>
                    Выбрать все
                </TemplateText>
                <TemplateText
                    style={{
                        cursor: selectDelButton ? 'pointer' : '',
                        fontSize: '1.4em',
                        fontWeight: selectDelButton ? 'normal' : 300,
                        color: selectDelButton ? '#686868' : '#9F9F9F'
                    }}
                    onClick={() => {
                        delSelectedRow();
                    }}>
                    Удалить
                </TemplateText>
            </div>
            <Table>
                <thead>
                    <TemplateTr style={{ boxShadow: '4px 4px 4px rgba(0, 0, 0, 0.05)' }}>
                        <TemplateTh scope="col" style={{ width: '2.6em' }}></TemplateTh>
                        <TemplateTh scope="col" style={{ width: '20%' }}>
                            Имя
                        </TemplateTh>
                        <TemplateTh scope="col" style={{ width: '8em', minWidth: '8em' }}>
                            Тип
                        </TemplateTh>
                        <TemplateTh scope="col" style={{ width: '40%' }}>
                            Входящие данные(SourceIn)
                        </TemplateTh>
                        <TemplateTh scope="col" style={{ width: '40%' }}>
                            Коментарий
                        </TemplateTh>
                    </TemplateTr>
                </thead>
                <tbody ref={bodyContainer}>
                    {inpArr.map((row: any, ind) => {
                        return (
                            <TemplateTr key={row.name + uniqID}>
                                <TemplateTd style={{ width: '2.6em' }} key={row.name}>
                                    <input type="checkbox" value={ind} onClick={checkToSelect} />
                                </TemplateTd>
                                <TemplateTd style={{ width: '20%' }}>
                                    <TemplateInput
                                        style={inCorrectValue === ind ? { outline: '0.4px solid #F87979' } : {}}
                                        autoFocus={inCorrectValue === ind ? true : false}
                                        defaultValue={row.name}
                                        onChange={(e) => {
                                            checkCorrectValue(e.target.value, ind);
                                        }}
                                        onBlur={(e) => {
                                            if (inCorrectValue === null) {
                                                inpCallBack && inpCallBack('name', e.target.value, ind);
                                                blurCallBack && blurCallBack();
                                            } else {
                                                e.currentTarget.value = e.currentTarget.defaultValue;
                                                setInCorrectValue(null);
                                            }
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                if (inCorrectValue === null) {
                                                    inpCallBack && inpCallBack('name', e.currentTarget.value, ind);
                                                    blurCallBack && blurCallBack();
                                                } else {
                                                    e.currentTarget.value = e.currentTarget.defaultValue;
                                                    setInCorrectValue(null);
                                                }
                                                e.currentTarget.blur();
                                            }
                                        }}
                                    />
                                </TemplateTd>
                                <TemplateTd style={{ width: '8em', minWidth: '8em' }}>
                                    <TemplateSelect
                                        autoFocus={ind + 1 === inpArr.length && focusOnNewRow ? true : false}
                                        defaultValue={row.type}
                                        onChange={(e) => inpCallBack && inpCallBack('type', e.target.value, ind)}
                                        onBlur={() => {
                                            focusOnNewRow && setFocusOnNewRow(false);
                                            blurCallBack && blurCallBack();
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                focusOnNewRow && setFocusOnNewRow(false);
                                                blurCallBack && blurCallBack();
                                                e.currentTarget.blur();
                                            }
                                        }}>
                                        {arrTypes.map((tp) => {
                                            return <option key={tp}>{tp}</option>;
                                        })}
                                    </TemplateSelect>
                                </TemplateTd>
                                <TemplateTd style={{ width: '40%' }}>
                                    <TemplateInput
                                        defaultValue={row.incData}
                                        title={row.incData}
                                        onChange={(e) => inpCallBack && inpCallBack('incData', e.target.value, ind)}
                                        onBlur={() => {
                                            blurCallBack && blurCallBack();
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                blurCallBack && blurCallBack();
                                                e.currentTarget.blur();
                                            }
                                        }}
                                    />
                                </TemplateTd>
                                <TemplateTd style={{ width: '40%' }}>
                                    <TemplateInput
                                        defaultValue={row.label}
                                        title={row.label}
                                        onChange={(e) => inpCallBack && inpCallBack('label', e.target.value, ind)}
                                        onBlur={() => {
                                            blurCallBack && blurCallBack();
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                blurCallBack && blurCallBack();
                                                e.currentTarget.blur();
                                            }
                                        }}
                                    />
                                </TemplateTd>
                            </TemplateTr>
                        );
                    })}

                    <TemplateTr
                        key={'addNewTemplateRow' + uniqID}
                        onBlur={(e) => {
                            if (inCorrectValue === null) {
                                addNewData(e.currentTarget);
                            }
                        }}>
                        <TemplateTd style={{ width: '2.6em', minWidth: '2.6em' }}></TemplateTd>
                        <TemplateTd style={{ width: '20%' }}>
                            <TemplateInput
                                style={
                                    inCorrectValue === 'addNewTemplateRow'
                                        ? { outline: '0.4px solid #F87979' }
                                        : { border: '0.4px solid #CCCCCC', width: '100%' }
                                }
                                placeholder={'<empty>'}
                                onChange={(e) => {
                                    checkCorrectValue(e.target.value, 'addNewTemplateRow');
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.currentTarget.blur();
                                    }
                                }}
                            />
                        </TemplateTd>
                        <TemplateTd style={{ width: '8em', minWidth: '8em' }}>
                            <TemplateSelect
                                defaultValue={'string'}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.currentTarget.blur();
                                    }
                                }}>
                                {arrTypes.map((tp) => {
                                    return <option key={tp}>{tp}</option>;
                                })}
                            </TemplateSelect>
                        </TemplateTd>
                        {/*<TemplateTd style={{ width: '8em', minWidth: '8em' }}><TemplateInput style={{ border: '0.4px solid #CCCCCC', width: '100%' }} onKeyDown={e => { if (e.key === 'Enter') { e.currentTarget.blur() } }} /></TemplateTd>*/}
                        <TemplateTd style={{ width: '40%' }}>
                            <TemplateInput
                                style={{ border: '0.4px solid #CCCCCC', width: '100%' }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.currentTarget.blur();
                                    }
                                }}
                            />
                        </TemplateTd>
                        <TemplateTd style={{ width: '40%' }}>
                            <TemplateInput
                                style={{ border: '0.4px solid #CCCCCC', width: '100%' }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.currentTarget.blur();
                                    }
                                }}
                            />
                        </TemplateTd>
                    </TemplateTr>
                </tbody>
            </Table>
        </Card>
    );
};

interface INamedSetsView {
    inpArr: any[];
    uniqID: string;
    inpCallBack?: Function;
    blurCallBack?: Function;
    addNewNamedSet?: Function;
    delNamedSet?: Function;
}
const NamedSetsView: React.FC<INamedSetsView> = ({
    inpArr,
    uniqID,
    inpCallBack,
    blurCallBack,
    addNewNamedSet,
    delNamedSet
}) => {
    const bodyContainer: React.LegacyRef<HTMLTableSectionElement> = useRef(null);
    const selectAllBool = useRef(false);
    const [focusOnNewRow, setFocusOnNewRow] = useState<any>(false);
    const [inCorrectValue, setInCorrectValue] = useState<any>(null);
    const [selectDelButton, setSelectDelButton] = useState<any>(false);
    const [selectAllSelButton, setSelectAllSelButton] = useState<any>(false);

    const checkCorrectValue = (valueName: any, ind: any) => {
        let findInd = inpArr.findIndex((r) => r.VALUE === Number(valueName));
        if ((findInd > -1 || valueName.length === 0) && findInd !== ind) {
            setInCorrectValue(ind);
        } else {
            inCorrectValue !== null && setInCorrectValue(null);
        }
        if (ind === 'addNewNamedSetRow' && String(valueName).length === 0) {
            inCorrectValue !== null && setInCorrectValue(null);
        }
    };

    const addNewData = (tr: any) => {
        let inp = tr.querySelectorAll('input');
        if (inp[0].value.length !== 0) {
            let newData = {
                VALUE: Number(inp[0].value),
                EN: inp[1].value,
                RU: inp[2].value
            };
            addNewNamedSet && addNewNamedSet(newData);
            setFocusOnNewRow(true);
            inp.forEach((inp: any) => {
                inp.value = '';
            });
        }
    };

    useEffect(() => {
        checkToSelect();
    });

    const checkToSelect = () => {
        if (bodyContainer.current) {
            let checkBoxs: any = bodyContainer.current.querySelectorAll('input[type="checkbox"]');
            let countChecked: number = 0;
            for (let cnt = 0; cnt < checkBoxs.length; cnt++) {
                if (checkBoxs[cnt].checked) {
                    countChecked++;
                }
            }
            console.log(countChecked, checkBoxs.length);
            if (countChecked === 0) {
                setSelectDelButton(false);
                setSelectAllSelButton(false);
            } else if (countChecked === checkBoxs.length) {
                setSelectAllSelButton(true);
                setSelectDelButton(true);
            } else {
                setSelectDelButton(true);
                setSelectAllSelButton(false);
            }
        }
    };
    const selectAll = () => {
        if (bodyContainer.current) {
            let checkBoxs = bodyContainer.current.querySelectorAll('input[type="checkbox"]');
            checkBoxs.forEach((box: any) => {
                if (selectAllBool.current) {
                    box.checked = false;
                } else {
                    box.checked = true;
                }
            });
            selectAllBool.current = !selectAllBool.current;
            checkToSelect();
        }
    };

    const delSelectedRow = () => {
        if (selectDelButton) {
            if (bodyContainer.current) {
                let checkBoxs = bodyContainer.current.querySelectorAll('input[type="checkbox"]');
                let massForDel: any[] = [];
                checkBoxs.forEach((box: any) => {
                    if (box.checked) {
                        massForDel.push(box.value);
                    }
                });
                //checkBoxs.forEach((box:any) => { box.checked = false; })
                delNamedSet && delNamedSet(massForDel);
                checkToSelect();
            }
        }
    };

    const createTable = () => {
        return (
            <Card style={{ width: '100%' }}>
                <div style={{ display: 'flex' }}>
                    <TemplateText
                        style={{
                            cursor: 'pointer',
                            fontSize: '1.4em',
                            fontWeight: selectAllSelButton ? 'normal' : 300,
                            color: selectAllSelButton ? '#686868' : '#9F9F9F'
                        }}
                        onClick={() => {
                            selectAll();
                        }}>
                        Выбрать все
                    </TemplateText>
                    <TemplateText
                        style={{
                            cursor: selectDelButton ? 'pointer' : '',
                            fontSize: '1.4em',
                            fontWeight: selectDelButton ? 'normal' : 300,
                            color: selectDelButton ? '#686868' : '#9F9F9F'
                        }}
                        onClick={() => {
                            delSelectedRow();
                        }}>
                        Удалить
                    </TemplateText>
                </div>
                <Table>
                    <thead>
                        <TemplateTr style={{ boxShadow: '4px 4px 4px rgba(0, 0, 0, 0.05)' }}>
                            <TemplateTh scope="col" style={{ width: '2.6em', minWidth: '2.6em' }}></TemplateTh>
                            <TemplateTh scope="col" style={{ width: '8em', minWidth: '8em' }}>
                                Значение
                            </TemplateTh>
                            <TemplateTh scope="col">EN</TemplateTh>
                            <TemplateTh scope="col">RU</TemplateTh>
                        </TemplateTr>
                    </thead>
                    <tbody ref={bodyContainer}>
                        {inpArr.map((row: any, ind) => {
                            return (
                                <TemplateTr key={row.VALUE + uniqID}>
                                    <TemplateTd key={row.VALUE} style={{ width: '2.6em', minWidth: '2.6em' }}>
                                        <input type="checkbox" value={ind} onClick={checkToSelect} />
                                    </TemplateTd>
                                    <TemplateTd style={{ width: '8em', minWidth: '8em' }}>
                                        <TemplateInput
                                            style={
                                                inCorrectValue === ind
                                                    ? { outline: '0.4px solid #F87979', textAlign: 'end' }
                                                    : { textAlign: 'end' }
                                            }
                                            autoFocus={inCorrectValue === ind ? true : false}
                                            defaultValue={row.VALUE}
                                            onChange={(e) => {
                                                checkCorrectValue(Number(e.target.value), ind);
                                            }}
                                            onBlur={(e) => {
                                                if (inCorrectValue === null) {
                                                    inpCallBack && inpCallBack('VALUE', Number(e.target.value), ind);
                                                    blurCallBack && blurCallBack();
                                                } else {
                                                    e.currentTarget.value = e.currentTarget.defaultValue;
                                                    setInCorrectValue(null);
                                                }
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    if (inCorrectValue === null) {
                                                        inpCallBack &&
                                                            inpCallBack('VALUE', Number(e.currentTarget.value), ind);
                                                        blurCallBack && blurCallBack();
                                                    } else {
                                                        e.currentTarget.value = e.currentTarget.defaultValue;
                                                        setInCorrectValue(null);
                                                    }
                                                    e.currentTarget.blur();
                                                }
                                            }}
                                        />
                                    </TemplateTd>
                                    <TemplateTd>
                                        <TemplateInput
                                            autoFocus={ind + 1 === inpArr.length && focusOnNewRow ? true : false}
                                            defaultValue={row.EN}
                                            onChange={(e) => inpCallBack && inpCallBack('EN', e.target.value, ind)}
                                            onBlur={() => {
                                                focusOnNewRow && setFocusOnNewRow(false);
                                                blurCallBack && blurCallBack();
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    focusOnNewRow && setFocusOnNewRow(false);
                                                    blurCallBack && blurCallBack();
                                                    e.currentTarget.blur();
                                                }
                                            }}
                                        />
                                    </TemplateTd>
                                    <TemplateTd>
                                        <TemplateInput
                                            defaultValue={row.RU}
                                            onChange={(e) => inpCallBack && inpCallBack('RU', e.target.value, ind)}
                                            onBlur={() => {
                                                blurCallBack && blurCallBack();
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    blurCallBack && blurCallBack();
                                                    e.currentTarget.blur();
                                                }
                                            }}
                                        />
                                    </TemplateTd>
                                </TemplateTr>
                            );
                        })}
                        <TemplateTr
                            key={'addNewNamedSetRow' + uniqID}
                            onBlur={(e) => {
                                if (inCorrectValue === null) {
                                    addNewData(e.currentTarget);
                                }
                            }}>
                            <TemplateTd style={{ width: '2.6em', minWidth: '2.6em' }}></TemplateTd>
                            <TemplateTd style={{ width: '8em', minWidth: '8em' }}>
                                <TemplateInput
                                    style={
                                        inCorrectValue === 'addNewNamedSetRow'
                                            ? { outline: '0.4px solid #F87979', width: '100%', textAlign: 'end' }
                                            : { border: '0.4px solid #CCCCCC', width: '100%', textAlign: 'end' }
                                    }
                                    type={'number'}
                                    placeholder={'<empty>'}
                                    onChange={(e) => {
                                        checkCorrectValue(e.target.value, 'addNewNamedSetRow');
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.currentTarget.blur();
                                        }
                                    }}
                                />
                            </TemplateTd>
                            <TemplateTd>
                                <TemplateInput
                                    style={{ border: '0.4px solid #CCCCCC', width: '100%' }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.currentTarget.blur();
                                        }
                                    }}
                                />
                            </TemplateTd>
                            <TemplateTd>
                                <TemplateInput
                                    style={{ border: '0.4px solid #CCCCCC', width: '100%' }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.currentTarget.blur();
                                        }
                                    }}
                                />
                            </TemplateTd>
                        </TemplateTr>
                    </tbody>
                </Table>
            </Card>
        );
    };

    return createTable();
};

interface IWarningWindow {
    message: string | undefined;
    cancelCB: () => void;
    confirmCB: () => void;
}
const WarningWindow: React.FC<IWarningWindow> = ({ message, cancelCB, confirmCB }) => {
    return (
        <div
            style={{
                position: 'absolute',
                height: '100%',
                width: '100%',
                top: 0,
                left: 0,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center'
            }}
            onClick={cancelCB}>
            <div
                style={{
                    maxWidth: '36.6em',
                    width: '100%',
                    background: '#fff',
                    boxShadow: '0px 17px 14px rgba(0, 0, 0, 0.08)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                }}
                onClick={(e) => e.stopPropagation()}>
                <div
                    style={{
                        height: '3em',
                        width: '100%',
                        background: '#E8F3F5',
                        boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.1)'
                    }}></div>
                <div
                    style={{
                        height: '5em',
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                    <img src={'static/images/trashCan.svg'} />
                </div>
                <div
                    style={{
                        width: '90%',
                        textAlign: 'center'
                    }}>
                    <text style={{ fontSize: '1.6em', fontWeight: 300, color: '#626161' }}>{message}</text>
                </div>
                <div
                    style={{
                        height: '5.4em',
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                    <Button text={'Отмена'} type={'white'} fontWeightLight onClick={cancelCB} />
                    <Button fontWeightLight type={'white'} text={'Удалить'} onClick={confirmCB} />{' '}
                </div>
            </div>
        </div>
    );
};
